export default __webpack_public_path__ + "static/media/h-right_s.b4f0f900.jpg";